import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './main-component/app';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";

import { render } from "react-dom";

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-55LN4L2Q' 
};

TagManager.initialize(tagManagerArgs);

render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
